<template>
  <div class="container bg-white rounded p-4 my-4">
    <CAlert
      color="danger"
      :closeButton="true"
      :show.sync="hasError">
      {{error.message}}
    </CAlert>

    <div class="client-performance">
      <div class="card mb-0">
        <div class="card-header">
          <div class="d-md-flex">
            <label for="">KPI por </label>
            <div class="my-auto d-md-flex tabs-selector">
              <button
                @click="changeType('monthly')"
                :class="options.type === 'monthly' ? 'active' : ''">
                Mes
              </button>
              <button
                @click="changeType('weekly')"
                :class="options.type === 'weekly' ? 'active' : ''">
                Semana
              </button>
            </div>

            <div class="my-auto mx-md-3 d-flex">
              <label>
                {{options.type === 'monthly' ? 'Mes' : 'Semana' }}
              </label>
              <select
                class="form-control"
                @change="getServiceOrdersReport"
                v-model="options.value">
                <option v-for="option in values" :key="option.value" :value="option.value">
                  {{ option.text }}
                </option>
              </select>
            </div>

            <div class="my-auto d-flex">
              <label>Año</label>
              <select
                class="form-control"
                @change="getServiceOrdersReport"
                v-model="options.year"
              >
                <option v-for="option in selectOptions.years" :key="option" :value="option">
                  {{option}}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div>
            <div class="cards-wrapper">
              <div class="card">
                <h4>Nuevos clientes</h4>
                <span
                  class="text-success"
                  v-if="!hasError && !isLoading"
                >{{performance.total}}</span>
              </div>
            </div>
          </div>
          <div>
            <div class="card big-card">
              <div class="card-header content-center">
                <h4>Crecimiento de clientes</h4>
              </div>
              <div class="card-body row text-center">
                <div class="col">
                  <span
                    v-if="!hasError && !isLoading"
                    class="text-value-xl"
                    :class="performance.increase.total <= 0 ? 'text-danger' : 'text-success'"
                  >
                    {{performance.increase.total}}
                  </span>
                </div>
                <div class="c-vr"></div>
                <div class="col">
                  <span
                    v-if="!hasError && !isLoading"
                    class="text-value-xl"
                    :class="performance.increase.total <= 0 ? 'text-danger' : 'text-success'">
                    {{performance.increase.percentage}}%
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies */
import moment from 'moment'
import { mapGetters } from 'vuex'

import 'moment-timezone'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

import { getErrorMessage } from '../common/errors'
import queryparser from '../utils/queryparser'
import { getSelectOptions } from '../utils/date'

export default {
  name: 'Services',
  data: () => ({
    error: {},
    performance: {},
    year: moment().year(),
    options: {
      type: 'monthly',
      param: 'month',
      year: moment().year(),
      value: moment().month() + 1
    },
    selectOptions: {
      monthly: [],
      weekly: [],
      years: []
    }
  }),
  computed: {
    ...mapGetters('auth', ['isCompanyAdmin']),
    values() {
      const { type } = this.options
      const isWeekly = type === 'weekly'
      return isWeekly ? this.selectOptions.weekly : this.selectOptions.monthly
    },
    hasError() {
      return this.error && Object.keys(this.error).length
    }
  },
  watch: {
    'options.type': function () {
      this.getServiceOrdersReport()
    },
    'options.year': function () {
      this.getServiceOrdersReport()
    }
  },
  mounted() {
    this.getServiceOrdersReport()
    this.setSelectOptions()
  },
  methods: {
    setSelectOptions() {
      const { weeks, months, years } = getSelectOptions(this.options.year, { baseYear: this.year })
      this.selectOptions.weekly = weeks
      this.selectOptions.monthly = months
      this.selectOptions.years = years
      this.changeType(this.options.type)
    },
    changeType(type) {
      const isWeekly = type === 'weekly'
      const date = moment().set({ year: this.options.year })
      this.options.type = isWeekly ? 'weekly' : 'monthly'
      this.options.param = isWeekly ? 'week' : 'month'

      if (moment().year() === this.options.year) {
        this.options.value = isWeekly ? date.isoWeek() : date.month() + 1
      }
    },
    async getServiceOrdersReport() {
      try {
        const {
          type, param, value, year
        } = this.options
        const query = queryparser.parse({ type, [param]: value, year })
        const { data } = await this.axios.get(`customers/report/performance?${query}`)
        this.performance = data
      } catch (err) {
        this.err = getErrorMessage(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.client-performance{
  > .card{
    > .card-header{
      display: flex;
      .tabs-selector{
        border: 1px solid #ccc;
        display: flex;
        height: 35px;
        border-radius: 4px;
        button{
          border: none;
          background-color: #fff;
          outline: none;
          color: #000015;
          min-width: 80px;
          border-right: 1px solid #ccc;
          border-radius: 4px;
          &.active{
            background-color: #5B2AE0;
            color: white;
          }
          &:last-child{
            border-right: 0;
          }
        }
      }
      >div{
        label{
          margin: auto 0;
        }
        select{
          margin: auto 0 auto 8px;
        }
        &:last-child{
          margin-left: 16px;
        }
      }
    }
    > .card-body{
      display: flex;
      flex-direction: column;
      @media(min-width: 768px){
        flex-direction: row;
      }
      >div{
        display: flex;
        .card{
          margin: 4px;
          padding: 8px;
          text-align: center;
          span{
            font-size: 24px;
            font-weight: bold;
            margin: auto;
          }
          &.finished-services,
          &.canceled-services{
            width: 110px;
          }
        }
        .big-card{
          .card-body{
            .col{
              display: flex;
              span{
                margin: auto;
              }
            }
          }
        }
        &:first-child{
          display: flex;
          flex-direction: column;
          margin: 0 auto;
          @media(min-width: 768px){
            margin: 0 0 0 auto;
          }
          .cards-wrapper{
            height: 100%;
            display: flex;
          }
          .card{
            p{
              font-size: 15px;
              font-weight: bold;
            }
          }
          .big-card{
            width: calc(100% - 110px);
            @media(min-width: 1200px){
              max-width: 300px;
            }
          }
        }
        &:last-child{
          margin: 0 auto;
          @media(min-width: 768px){
            margin: 0 auto 0 0;
          }
        }
      }
    }
  }
}
</style>
